import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';
import {
    ICriticalOrgUpdateItem,
    ICriticalOrgUpdatesSearchPayload,
} from './models/critical-organization-updates.service';

export interface IUpsertNewsPayload {
    id?: string;
    documentId?: string;
    documentType: number;
    headline: string;
    distributionId: string;
    validFromDate: string;
    validThroughDate?: string;
    language: number;
    document: string;
}

export interface IUpsertNewsResponse {
    message: string;
    id: string;
    documentId: string;
}

export interface IDeleteNewsResponse {
    message: string;
    id: string;
    deleted: boolean;
    documentDeleted: boolean;
}

export class CriticalOrganizationUpdatesService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };

    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    public async upsertNews(
        payload: IUpsertNewsPayload,
    ): Promise<AxiosResponse<IUpsertNewsResponse>> {
        return this.post('upsertNews', payload);
    }

    public async deleteNews(
        id: string,
    ): Promise<AxiosResponse<IDeleteNewsResponse>> {
        return this.post('deleteNews', { id });
    }

    public async getCriticalOrgUpdates(
        payload: ICriticalOrgUpdatesSearchPayload,
    ): Promise<AxiosResponse<ICriticalOrgUpdateItem[]>> {
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        return this.client.sendRequest({
            method: HttpMethod.post,
            url: `${this.dealerPortalUrlStructure}/getCriticalOrgUpdates`,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: { ...payload, jwtToken: permissionsToken },
        });
    }

    private async post(endpoint: string, data: object): Promise<AxiosResponse> {
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        return this.client.sendRequest({
            method: HttpMethod.post,
            url: `${this.dealerPortalUrlStructure}/${endpoint}`,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: { ...data, jwtToken: permissionsToken },
        });
    }
}
